<template>
    <v-layout wrap>
        <v-flex xs12 v-if="!hideLocalSearch">
            <v-text-field
                :loading="loading"
                prepend-icon="search"
                @keyup.enter="searchClients"
                @click:clear="clear"
                v-model="searchTerm"
                clearable
                large
            />
        </v-flex>
        <v-flex xs12 text-xs-center>
            <v-progress-linear class="mt-2" height="2" color="primary" indeterminate v-if="loading"/>
            <v-slide-y-transition>

                <div v-show="!loading">

                    <div class="my-1"></div>
                    <v-layout wrap>

                        <v-flex xs12 pa-3 text-xs-center v-if="clients.length === 0">
                            <h1 class="caption font-weight-light">No se han encontrado pacientes.</h1>
                        </v-flex>

                        <template v-else>
                            <v-flex xs12 md4 lg3 xl2 v-for="client in clients" :key="client.id" pa-1>
                                <client-card :client="client" @click="showDetails(client)"/>
                            </v-flex>
                            <v-flex xs12 md4 lg3 xl2 v-if="nextUrl" pa-1>
                                <v-card @click="getClients" elevation="0" hover color="grey lighten-1" dark
                                        class="fill-height kim-card d-flex align-center justify-center"
                                        min-height="127px">
                                    <v-progress-circular v-if="loadingMore" indeterminate color="primary" width="1"
                                                         size="40"/>
                                    <template v-else>
                                        <v-layout wrap class="primary--text">
                                            <v-flex xs12>
                                                <v-icon color="primary" size="30">fa-plus</v-icon>
                                            </v-flex>
                                            <v-flex xs12>
                                                <span class="subtitle">Ver mas</span>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-card>
                            </v-flex>
                        </template>
                    </v-layout>
                </div>

            </v-slide-y-transition>
        </v-flex>
        <v-flex xs12 text-xs-center v-if="total && !loading">
            <v-divider class="mt-2"></v-divider>
            <span class="caption">Mostrando {{ clients.length }} de {{ total }}</span>
        </v-flex>
        <client-details v-if="selectedClient" :client="selectedClient" ref="clientDetails"/>
    </v-layout>
</template>

<script>

import {ApiUtils} from "@/utils/ApiUtils";
import {mapState} from 'vuex'
import {getFakeAvatar, debounce} from "@/utils/Common";
import ClientDetails from "./ClientDetails";
import ClientCard from "./ClientCard";

export default {
    components: {ClientCard, ClientDetails},
    props: {
        labels: {
            type: Array,
            default: () => []
        },
        hideLocalSearch: {
            type: Boolean,
            default: false
        },
        search: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            clients: [],
            selectedClient: null,
            searchTerm: '',
            error: '',
            loading: false,
            loadingMore: false,
            nextUrl: null,
            total: 0
        }
    },
    mounted() {
        const vm = this
        vm.getClients()
    },
    methods: {
        getFakeAvatar,
        showDetails(client) {
            const vm = this
            vm.selectedClient = client
            vm.$nextTick(function () {
                vm.$refs.clientDetails.show()
            })
        },
        clear() {
            const vm = this
            if (!vm.search) return false
            vm.search = ''
            vm.getClients()
        },
        debouncedSearchClient: debounce(function () {
            this.searchClients()
        }, 500),
        searchClients() {
            const vm = this
            vm.nextUrl = null
            vm.$nextTick(function () {
                vm.getClients()
            })
        },
        async getClients() {

            const vm = this
            if (!vm.currentProvider || vm.loading) return false

            let payload = {}
            let response
            if (!vm.nextUrl) {
                if (vm.labels && vm.labels.length > 0) {
                    payload.labels = vm.labels
                }

                if (vm.searchTerm) {
                    payload.term = vm.searchTerm
                }

                vm.loading = true
                response = await ApiUtils.makeGet(
                    `providers/${vm.currentProvider.id}/clients`, payload
                )
                vm.loading = false

            } else {
                vm.loadingMore = true
                response = await ApiUtils.makeGet(vm.nextUrl)
                vm.loadingMore = false
            }

            if (!response.ok) {
                const json = await response.json()
                vm.error = json.message || 'Error cargando el listado'
                return false
            }

            const json = await response.json()
            vm.clients = vm.nextUrl ?
                [...vm.clients, ...json.result.clients.data]
                : json.result.clients.data

            vm.total = json.result.clients.total
            vm.nextUrl = json.result.clients.next_page_url

        }
    },
    computed: {
        ...mapState(['currentProvider'])
    },
    watch: {
        loading(val) {
            this.$emit('loading', val)
        },
        labels() {
            this.debouncedSearchClient()
        },
        search(val) {
            this.searchTerm = val
            this.debouncedSearchClient()
        }
    }
}
</script>

<style scoped>

</style>